import React, { useEffect, useState, useRef, useCallback } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { useUser } from "../../context/Usercontext";
import { v4 as uuidv4 } from "uuid";
import "./Viewer.css"
import zoomIn from './export-zoomin.svg'
import zoomOut from './ri_subtract-fill.svg'
import downloadIcon from './download.svg';
import darkModeIcon from './export-moon.svg';
import lightModeIcon from './export-sun.svg';
import Search_lite from './search_iocn_lite.svg'
import Search_Black from './search_icon_black.svg'
import close_icon from './close_icon.svg'

import zoomInlite from './export-zoomin_lite.svg'
import zoomoutlite from './ri_subtract-fill_lite.svg'
import darkModeIconlite from './export-moon_lite.svg';
import lightModeIconlite from './export-sun_lite.svg';
import downloadIconlite from './downlaod_lite.svg';

import sendnowlite from './sendnow_lite.svg'

import arrow from './export.svg'
import LoadingWave from "../Loader";
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
import { Modal, Input, List } from 'antd';
import { CloseOutlined } from '@ant-design/icons'; // Already available in Ant Design




const DocxViewer = ({ url, mimeType,totalPages }) => {


  const { ip, location, userId, region, os, device, browser } = useUser();


  const [currentPage, setCurrentPage] = useState(1);
    const [darkMode, setDarkMode] = useState(true);
    const [totalPagess, setTotalPages] = useState(0);

  
    const toggleTheme = () => setDarkMode(prev => !prev);
  
    const zoomPluginInstance = zoomPlugin();
    const zoomPluginRef = useRef(zoomPluginInstance);
    const { ZoomInButton, ZoomOutButton } = zoomPluginRef.current;
    const [zoomLevel, setZoomLevel] = useState(1.5); // default scale
    const pageNavigationPluginInstance = pageNavigationPlugin();
    const { jumpToPage } = pageNavigationPluginInstance;
  
    const handleZoomIn = () => {
      const newZoom = Math.min(zoomLevel + 0.2, 3);
      zoomPluginRef.current.zoomTo(newZoom);
      setZoomLevel(newZoom);
    };
  
    const handleZoomOut = () => {
      const newZoom = Math.max(zoomLevel - 0.2, 0.5);
      zoomPluginRef.current.zoomTo(newZoom);
      setZoomLevel(newZoom);
    };
  
    const [pageInput, setPageInput] = useState('');
    const viewerRef = useRef(null);
  
    const goToPage = (e) => {
      e.preventDefault();
      const pageNum = parseInt(pageInput, 10);
      if (!isNaN(pageNum)) {
        jumpToPage(pageNum - 1); // 0-based index
      }
    };
  
  
    // Auto download handler
     const handleDownload = async () => {
      // tell the link-handler to lay off
      ignoreLinkRef.current = true;
    
      try {
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error('Network error');
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileUrl.split('/').pop() || 'download.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(blobUrl);
      } catch (err) {
        console.error('Download failed', err);
      } finally {
        // after 500ms, re-enable link handling
        setTimeout(() => {
          ignoreLinkRef.current = false;
        }, 500);
      }
    };
    

    const openSearchPopup = () => setSearchPopupVisible(true);
const closeSearchPopup = () => {
  setSearchPopupVisible(false);
  setSearchQueryText('');
  setPdfMatches([]);
};

const extractSnippet = (text, keyword) => {
  const index = text.toLowerCase().indexOf(keyword.toLowerCase());
  if (index === -1) return '';
  const start = Math.max(index - 25, 0);
  const end = Math.min(index + 50, text.length);
  return text.substring(start, end) + '...';
};

const performPdfSearch = async () => {
  // 1) Grab and trim the keyword
  const keyword = searchQueryText.trim();
  if (!pdfDocumentInstance || !keyword) return;

  // 2) If it’s new, push into the ref immediately
  if (!searchKeywordsRef.current.includes(keyword)) {
    searchKeywordsRef.current.push(keyword);

    // Also update React state (so your UI/props see it)
    setSearchKeywords([...searchKeywordsRef.current]);
  }

  // 3) Now run your PDF‐search logic as before
  const results = [];
  const lowerKeyword = keyword.toLowerCase();

  for (let i = 1; i <= pdfDocumentInstance.numPages; i++) {
    const page = await pdfDocumentInstance.getPage(i);
    const textContent = await page.getTextContent();
    const fullText = textContent.items.map(item => item.str).join(' ');
    if (fullText.toLowerCase().includes(lowerKeyword)) {
      results.push({
        pageNum: i,
        snippet: extractSnippet(fullText, keyword),
      });
    }
  }

  setPdfMatches(results);
};


const handleMatchClick = (pgNum) => {
  setPageInput(String(pgNum));
  goToPage({ preventDefault: () => {} });
  closeSearchPopup();
};

const onPdfLoad = async (doc) => {
  setPdfDocumentInstance(doc);
  setTotalPages(doc.numPages); // if you already have this
};



  const [pdfjs, setPdfjs] = useState(null);
  const [pdfjsWorker, setPdfjsWorker] = useState(null);
 

  // Refs for tracking per-page time, timers, and analytics call status.
  const timeSpentRef = useRef({});
  const pageTimerRef = useRef(null);
  const visitedPagesRef = useRef(new Set());
  const milestoneVisitedPagesRef = useRef(0);
  const apiCalledRef = useRef(false);
  const ignoreLinkRef = useRef(false);

  // Ref to capture when the user leaves the tab.
  const lastLeaveTimeRef = useRef(null);
  // New ref for auto-close timer when viewer remains hidden > 1 min.
  const autoCloseTimerRef = useRef(null);

  const sessionIdRef = useRef(uuidv4());

  // State variables for tracking user interactions for analytics.
  const [totalClicks, setTotalClicks] = useState(0);
  const [selectedTexts, setSelectedTexts] = useState([]);
  const [linkClicks, setLinkClicks] = useState([]);
  const [pageVisitCount, setPageVisitCount] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [searchPopupVisible, setSearchPopupVisible] = useState(false);
const [searchQueryText, setSearchQueryText] = useState('');
const [searchKeywords, setSearchKeywords] = useState([]); // Holds all unique keywords
const searchKeywordsRef = useRef([]);  
const [pdfMatches, setPdfMatches] = useState([]);
const [pdfDocumentInstance, setPdfDocumentInstance] = useState(null);




  const fileUrl = url;

  // Set up initial analytics data.
  const [analyticsData, setAnalyticsData] = useState({
    ip: ip || "",
    location: location || "",
    userId: userId || "",
    region: region || "",
    os: os || "",
    device: device || "",
    browser: browser || "",
    pdfId: window.location.pathname.split("/").pop() || "",
    sourceUrl: url,
    totalPagesVisited: 0,
    totalTimeSpent: 0,
    pageTimeSpent: {},
    selectedTexts: [],
    totalClicks: 0,
    inTime: new Date().toISOString(), // Initial load time.
    outTime: null,
    mostVisitedPage: null,
    linkClicks: [],
    totalPages: 0,
  });

  // A ref to always have the latest analyticsData.
  const analyticsDataRef = useRef(analyticsData);
  useEffect(() => {
    analyticsDataRef.current = analyticsData;
  }, [analyticsData, selectedTexts, totalClicks, linkClicks]);

  // Get userId from localStorage and sessionStorage.
  const localStorageUserId = localStorage.getItem("userId");
  const sessionStorageUserId = sessionStorage.getItem("userId");

  // Identification API call: fires once after 3 seconds if userId is valid.
  const sendIdentificationRequest = useCallback(async () => {
    if (!userId || !window.location.pathname) return;

    const documentId = window.location.pathname.split("/").pop();
    const requestData = { userId, documentId, mimeType: "docx", sessionId: sessionIdRef.current };

    try {
      const response = await fetch("https://user-view-backend.vercel.app/api/user/identify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
      if (!response.ok) throw new Error("Failed to identify user");
      const result = await response.json();

    } catch (error) {
      console.error("Error sending identification request:", error);
    }
  }, [userId]);

  useEffect(() => {
    if (userId && userId.length > 15 && !apiCalledRef.current) {
      const timer = setTimeout(() => {
        sendIdentificationRequest();
        apiCalledRef.current = true;
      }, 10000); // 3-second delay

      return () => clearTimeout(timer);
    }
  }, [userId, sendIdentificationRequest]);

  

  // Handle userId API calls based on localStorage and sessionStorage.
  useEffect(() => {
    if (apiCalledRef.current) return;
    const delay = 1000; // 1-second delay

    const timer = setTimeout(() => {
      const isDataReady =
        ip &&
        location &&
        userId &&
        region &&
        os &&
        device &&
        browser &&
        !ip.includes("Detecting") &&
        !location.includes("Detecting") &&
        !userId.includes("Detecting") &&
        !region.includes("Detecting") &&
        !os.includes("Detecting") &&
        !device.includes("Detecting") &&
        !browser.includes("Detecting");

      if (localStorageUserId && sessionStorageUserId && localStorageUserId === sessionStorageUserId) {
        apiCalledRef.current = true;
      } else if (!localStorageUserId && !sessionStorageUserId && isDataReady && userId) {
        apiCalledRef.current = true;
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [localStorageUserId, sessionStorageUserId, userId, ip, location, region, os, device, browser]);

  useEffect(() => {
    if (device && device !== "Detecting...") {
      setIsMobile(device.toLowerCase().includes("mobile"));
    }
  }, [device]);

  // Update analyticsData when context values change.
  useEffect(() => {
    setAnalyticsData((prevData) => ({
      ...prevData,
      ip: ip || "",
      location: location || "",
      userId: userId || "",
      region: region || "",
      os: os || "",
      device: device || "",
      browser: browser || "",
    }));
  }, [ip, location, userId, region, os, device, browser]);

  // Dynamically load pdfjs and its worker.
  useEffect(() => {
    const loadPdfjs = async () => {
      const pdfjsModule = await import("pdfjs-dist/build/pdf");
      const pdfjsWorkerModule = await import("pdfjs-dist/build/pdf.worker.entry");
      pdfjsModule.GlobalWorkerOptions.workerSrc = pdfjsWorkerModule;
      setPdfjs(pdfjsModule);
      setPdfjsWorker(pdfjsWorkerModule);
    };
    loadPdfjs();
  }, []);

  // Start or restart the per-page time tracking timer.
  const startPageTimer = useCallback(() => {
    clearInterval(pageTimerRef.current);
    pageTimerRef.current = setInterval(() => {
      const page = currentPage;
      timeSpentRef.current[page] = (timeSpentRef.current[page] || 0) + 1;
      setAnalyticsData((prevData) => ({
        ...prevData,
        totalTimeSpent: prevData.totalTimeSpent + 1,
        pageTimeSpent: {
          ...prevData.pageTimeSpent,
          [page]: (prevData.pageTimeSpent[page] || 0) + 1,
        },
      }));
    }, 1000);
  }, [currentPage]);

  // Handle page changes.
  const handlePageChange = useCallback(
    (e) => {
      const newPage = e.currentPage + 1; // Pages are zero-indexed.
      clearInterval(pageTimerRef.current);

      if (document.visibilityState === "visible") {
        startPageTimer();
      }

      visitedPagesRef.current.add(newPage);
      const visitedPagesCount = visitedPagesRef.current.size;

      if (visitedPagesCount >= milestoneVisitedPagesRef.current + 10) {
        milestoneVisitedPagesRef.current = Math.floor(visitedPagesCount / 10) * 10;

      }

      setAnalyticsData((prevData) => ({
        ...prevData,
        totalPagesVisited: visitedPagesCount,
      }));

      setPageVisitCount((prevCount) => {
        const newCount = { ...prevCount, [newPage]: (prevCount[newPage] || 0) + 1 };
        let mostVisitedPage = null;
        let maxTimeSpent = 0;
        for (const [page, time] of Object.entries(timeSpentRef.current)) {
          if (time > maxTimeSpent) {
            mostVisitedPage = page;
            maxTimeSpent = time;
          }
        }
        setAnalyticsData((prevData) => ({
          ...prevData,
          mostVisitedPage: mostVisitedPage,
        }));
        return newCount;
      });

      setCurrentPage(newPage);
    },
    [startPageTimer]
  );

  // Track text selection on the PDF.
  const handleTextSelection = useCallback(() => {
    const selectedText = window.getSelection().toString().trim();
    if (selectedText) {
      const truncatedText = selectedText.length > 300 ? selectedText.slice(0, 300) : selectedText;
    
      setSelectedTexts((prevSelectedTexts) => {
        const existingText = prevSelectedTexts.find(
          (item) => item.selectedText === truncatedText && item.page === currentPage
        );
        if (existingText) {
          return prevSelectedTexts.map((item) =>
            item.selectedText === truncatedText && item.page === currentPage
              ? { ...item, count: item.count + 1 }
              : item
          );
        } else {
          return [...prevSelectedTexts, { selectedText: truncatedText, count: 1, page: currentPage }];
        }
      });
    }
  }, [currentPage]);

  // Intercept link clicks inside the PDF.
  const handleLinkClick = useCallback(
    (e) => {
      if (ignoreLinkRef.current) return;
      const linkElement = e.target.closest("a");
      if (linkElement) {
        e.preventDefault();
        const linkUrl = linkElement.href;
     
        window.open(linkUrl, "_blank");
        setLinkClicks((prevLinkClicks) => [
          ...prevLinkClicks,
          { page: currentPage, clickedLink: linkUrl },
        ]);
      }
    },
    [currentPage]
  );

  // General click handler to increment the click count.
  const handleClick = useCallback(() => {
    setTotalClicks((prev) => prev + 1);
  }, []);

  // ---------------------------------------------------------------------------
  // Updated Analytics Interval & Visibility Change Handler
  // ---------------------------------------------------------------------------
  const analyticsIntervalRef = useRef(null);
  const absenceTimesRef = useRef([]);

  const startAnalyticsInterval = useCallback(() => {
    analyticsIntervalRef.current = setInterval(() => {
      let payloadOutTime;
      const currentTime = new Date();

      if (lastLeaveTimeRef.current) {
        const leaveTime = new Date(lastLeaveTimeRef.current);
        const absenceDurationMs = currentTime - leaveTime;
        const absenceSeconds = Math.round(absenceDurationMs / 1000);

        const computedOutTime = new Date(currentTime - absenceDurationMs).toISOString();


        absenceTimesRef.current.push({
          leaveTime: leaveTime.toISOString(),
          returnTime: currentTime.toISOString(),
          absenceSeconds,
          computedOutTime,
        });

        payloadOutTime = computedOutTime;
      } else {
        payloadOutTime = currentTime.toISOString();
      }

      lastLeaveTimeRef.current = null;

      const finalData = {
        ...analyticsDataRef.current,
        outTime: payloadOutTime,
        userId,
        sessionId: sessionIdRef.current,  // <-- ADD THIS LINE
        selectedTexts,
        totalClicks,
        linkClicks,
        searchKeywords: searchKeywordsRef.current,
        absenceHistory: absenceTimesRef.current,
      };

      const sendAnalyticsData = async () => {
        try {
          const response = await fetch("https://user-view-backend.vercel.app/api/v1/Docx/DocxAnalytics", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(finalData),
          });
          if (!response.ok) throw new Error("Network response was not ok");
          const result = await response.json();
       
        } catch (error) {
          console.error("Error sending periodic analytics data:", error);
        }
      };
      sendAnalyticsData();
    }, 10000);
  }, [userId, selectedTexts, totalClicks, linkClicks]);

  useEffect(() => {
    startAnalyticsInterval();
    return () => {
      clearInterval(analyticsIntervalRef.current);
    };
  }, [startAnalyticsInterval]);

  // Listen for page visibility changes.
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        // Record the moment the user leaves the tab.
        lastLeaveTimeRef.current = new Date().toISOString();
        clearInterval(analyticsIntervalRef.current);
        analyticsIntervalRef.current = null;
        clearInterval(pageTimerRef.current);
        pageTimerRef.current = null;

        // Start auto-close timer for 20 minute of absence.
        autoCloseTimerRef.current = setTimeout(() => {
        
          window.close();
        }, 600000);
      } else if (document.visibilityState === "visible") {
        // Check if the absence time was > 20 minute.
        if (lastLeaveTimeRef.current) {
          const absenceDurationMs = new Date() - new Date(lastLeaveTimeRef.current);
          if (absenceDurationMs >= 600000) {
        
            window.close();
            return;
          }
        }

        // Clear any auto-close timer if user returns before 1 minute.
        if (autoCloseTimerRef.current) {
          clearTimeout(autoCloseTimerRef.current);
          autoCloseTimerRef.current = null;
        }
        if (!analyticsIntervalRef.current) {
          startAnalyticsInterval();
        }
        if (!pageTimerRef.current) {
          startPageTimer();
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [startAnalyticsInterval, startPageTimer]);

  // Simple throttle helper to limit execution frequency (for mobile events)
  const throttle = (func, delay) => {
    let lastCall = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        func(...args);
      }
    };
  };

  useEffect(() => {
    const mobileTextSelection = throttle(handleTextSelection, 500);
    const mobileClickHandler = throttle(handleClick, 500);
    const mobileLinkClick = throttle(handleLinkClick, 500);

    const desktopTextSelection = handleTextSelection;
    const desktopClickHandler = handleClick;
    const desktopLinkClick = handleLinkClick;

    if (isMobile) {
      document.addEventListener("touchend", mobileTextSelection, { passive: true });
      document.addEventListener("touchend", mobileClickHandler, { passive: true });
      document.addEventListener("touchend", mobileLinkClick, { passive: true });
      return () => {
        document.removeEventListener("touchend", mobileTextSelection);
        document.removeEventListener("touchend", mobileClickHandler);
        document.removeEventListener("touchend", mobileLinkClick);
      };
    } else {
      document.addEventListener("mouseup", desktopTextSelection);
      document.addEventListener("click", desktopClickHandler);
      document.addEventListener("click", desktopLinkClick);
      return () => {
        document.removeEventListener("mouseup", desktopTextSelection);
        document.removeEventListener("click", desktopClickHandler);
        document.removeEventListener("click", desktopLinkClick);
      };
    }
  }, [handleTextSelection, handleClick, handleLinkClick, isMobile]);

  if (!pdfjs || !pdfjsWorker) {
    return <LoadingWave />; 
  }

  const handleWidgetClick = () => {
    window.open("https://www.sendnow.live/", "_blank");
  };

  return (
  <div className={`main-background ${isMobile ? 'mobile-view' : ''} ${darkMode ? 'dark-theme' : 'light-theme'}`}>
    <div
      style={{ position: 'relative' }}
      className={`dashboard-container ${isMobile ? 'mobile-container' : ''}`}
    >
      <div className="widget-header-bar">
        <img
          src={darkMode ? sendnowlite : '/sendnow.svg'}
          className="widget-logo"
          alt="Logo"
          style={{ cursor: 'pointer' }}
          onClick={handleWidgetClick}
        />

        <div className="widget-controls">
          {/* Zoom In */}
          <button onClick={handleZoomIn} className="icon-button" title="Zoom In">
            <img
              src={darkMode ? zoomInlite : zoomIn}
              alt="Zoom In"
              className="export-icon"
            />
          </button>

          {/* Zoom Out */}
          <button onClick={handleZoomOut} className="icon-button" title="Zoom Out">
            <img
              src={darkMode ? zoomoutlite : zoomOut}
              alt="Zoom Out"
              className="export-icon"
            />
          </button>

          {/* Page Number Jump */}
          <form onSubmit={goToPage} className="page-jump-form">
            <input
              type="number"
              value={pageInput}
              onChange={(e) => setPageInput(e.target.value)}
              placeholder="Page #"
              className="page-jump-input"
            />
            <p>{totalPages || 4}</p>
            <button type="submit" className="page-jump-button">
              Go
            </button>
          </form>

        {/* Search Trigger (Using Download Icon) */}
<img
  src={darkMode ? Search_lite : Search_Black}
  alt="Search"
  onClick={openSearchPopup}
  className="export-icon"
  style={{ marginLeft: '10px', cursor: 'pointer' }}
/>


          {/* Download */}
          <button onClick={handleDownload} className="icon-button" title="Download PDF">
            <img
              src={darkMode ? downloadIconlite : downloadIcon}
              alt="Download"
              className="export-icon"
            />
          </button>

          {/* Theme Toggle */}
          <button onClick={toggleTheme} className="icon-button" title="Toggle Theme">
            <img
              src={darkMode ? lightModeIconlite : darkModeIcon}
              alt="Toggle Theme"
              className="export-icon"
            />
          </button>
        </div>
      </div>

      {/* PDF Viewer */}
      <Worker workerUrl={pdfjsWorker}>
        <Viewer
          fileUrl={fileUrl}
          defaultScale={isMobile ? 0.6 : 1.5}
          renderMode="canvas"
          onPageChange={handlePageChange}
          onDocumentLoad={({ doc }) => onPdfLoad(doc)}
          plugins={[zoomPluginInstance, pageNavigationPluginInstance]}
        />
      </Worker>
    </div>

    {/* Search Modal */}
<Modal
  title={
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ color: darkMode ? '#fff' : '#000' }}>Search PDF</span>
      <img
        src={close_icon }
        alt="Close"
        onClick={closeSearchPopup}
        style={{
          width: '20px',
          height: '25px',
          cursor: 'pointer',
         
         
        }}
      />
    </div>
  }
  open={searchPopupVisible}
  onCancel={closeSearchPopup}
  closable={false}
  footer={null}
  className={darkMode ? 'custom-dark-modal' : ''}
>
  <Input.Search
    placeholder="Search text..."
    enterButton="Search"
    value={searchQueryText}
    onChange={(e) => setSearchQueryText(e.target.value)}
    onSearch={performPdfSearch}
    style={{
      backgroundColor: darkMode ? '#333' : '#fff',
      color: darkMode ? '#fff' : '#000',
      borderColor: darkMode ? '#555' : undefined,
    }}
  />

  <div
    style={{
      maxHeight: '300px',
      overflowY: 'scroll',
      marginTop: 10,
      paddingRight: 6,
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    }}
    className="search-results-scroll"
  >
    <List
      dataSource={pdfMatches}
      locale={{
        emptyText: (
          <div style={{ textAlign: 'center', color: darkMode ? '#aaa' : '#999' }}>
            No matches found
          </div>
        ),
      }}
      renderItem={(item) => (
        <List.Item
          onClick={() => handleMatchClick(item.pageNum)}
          style={{ cursor: 'pointer', color: darkMode ? '#fff' : '#000' }}
        >
          <strong style={{ color: darkMode ? '#ccc' : '#000' }}>
            Page {item.pageNum}:
          </strong>{' '}
          {item.snippet.split(new RegExp(`(${searchQueryText})`, 'gi')).map((part, index) =>
            searchQueryText && part.toLowerCase() === searchQueryText.toLowerCase() ? (
              <span
                key={index}
                style={{
                  color: '#7c5832',
                  fontWeight: 'bold',
                  backgroundColor: darkMode ? '#444' : '#f0f0f0',
                  padding: '0 2px',
                  borderRadius: '2px',
                }}
              >
                {part}
              </span>
            ) : (
              <span key={index}>{part}</span>
            )
          )}
        </List.Item>
      )}
    />
  </div>

  <style>
    {`
      .search-results-scroll::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }

      .custom-dark-modal .ant-modal-content {
        background-color: #1f1f1f !important;
        color: #fff !important;
      }

      .custom-dark-modal .ant-modal-header {
        background-color: #1f1f1f !important;
        color: #fff !important;
        border-bottom: 1px solid #333;
      }

      .custom-dark-modal .ant-modal-title {
        color: #fff !important;
      }

      .custom-dark-modal .ant-modal-body {
        background-color: #1f1f1f !important;
        color: #fff !important;
      }

      .custom-dark-modal .ant-input,
      .custom-dark-modal .ant-input-affix-wrapper {
        background-color: #333 !important;
        color: #fff !important;
        border-color: #444 !important;
      }

      .custom-dark-modal .ant-input::placeholder {
        color: #aaa !important;
      }

  
        :where(.css-dev-only-do-not-override-5uvb3z).ant-input-search .ant-input-search-button {
      background-color: #7c5832 !important;
      border-color: #7c5832 !important;
      color: #fff !important;
    }

     :where(.css-mc1tut).ant-input-search >.ant-input-group >.ant-input-group-addon:last-child .ant-input-search-button {
        background-color: #7c5832 !important;
      border-color: #7c5832 !important;
      color: #fff !important;
      }
    `}
  </style>
</Modal>
  </div>
);

};

export default DocxViewer;
